import { useMutation } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const remove = async (data: { _id: string }) => {
  const response: TServerResponse = await request({
    url: apiUrls.homeServices.DELETE_SERVICE,
    method: "POST",
    data,
  });
  return response;
};

export const useRemoveServiceMutation = () => {
  return useMutation({ mutationFn: remove });
};
